import React from "react";

const RequirementIndicator = ({ required }) => {
  return required ? (
    <span className="text-danger fw-bold fs-px-12"> *</span>
  ) : (
    <span className="fw-normal text-lowercase"> (optional)</span>
  );
};

export default RequirementIndicator;
